import axios from "axios";
import { toast } from "react-toastify";
import { Urls, mainUrl } from "../apiUrls/apiUrl";

export const COMMON_API = {
  getProjectHandover,
  createProjectHandover,
  getDocumentRepository,
  createDocumentRepository,
  getPostHandoverComplaintForm,
  createPostHandoverComplaintForm,
  getLearningFormList,
  createLearningForm
};

function handleError(error) {
  if (error.response) {
    const { status, data } = error.response;
    if (status === 401) {
      toast.error("Unauthorized Access!");
    } else if ([400, 404, 409, 500].includes(status)) {
      toast.error(data?.message || "An error occurred.");
    }
  } else {
    toast.error("An unexpected error occurred.");
  }
  return Promise.reject(error);
}
function getAuthToken() {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return null;
  }
  return { token, state };
}
function getProjectHandover(payload) {
    const auth = getAuthToken();
    if (!auth) return Promise.reject("Token missing");
  
    const { token } = auth;
  
    return axios
      .post(`${mainUrl}api/Projects/GetProjectHandoverDetails`,payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => response.data)
      .catch(handleError);
}
function createProjectHandover(payload) {
    const auth = getAuthToken();
    if (!auth) return Promise.reject("Token missing");
  
    const { token } = auth;
  
    return axios
      .post(`${mainUrl}api/Projects/SaveProjectHandoverDetails`,payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => response.data)
      .catch(handleError);
}
function getDocumentRepository(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/DocumentRepository/GetDocumentRepositryDetails`,payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function createDocumentRepository(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/DocumentRepository/SaveDocumentRepositryDetails`,payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function getPostHandoverComplaintForm(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/PostHandOverComplaint/GetPostHandOverComplaintDetails`,payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function createPostHandoverComplaintForm(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/PostHandOverComplaint/SavePostHandOverComplaintDetail`,payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function getLearningFormList(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/Learning/GetLearningDetails`,payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
function createLearningForm(payload) {
  const auth = getAuthToken();
  if (!auth) return Promise.reject("Token missing");

  const { token } = auth;

  return axios
    .post(`${mainUrl}api/Learning/SavelearningDetails`,payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch(handleError);
}
 
  

